<script setup>
import { nextTick, onBeforeUnmount, onMounted, reactive, ref } from 'vue';

import AnalysisColumn from '../components/AnalysisColumn.vue';

defineProps({
  width: { type: Number },
  height: { type: Number },
});

const columnWidths = reactive([0, 0]);
const resizeObserver = ref(null);
const column1 = ref(null);
const column2 = ref(null);
// const gridContainer = ref(null);
const activeTab = ref('trends');

const updateColumnWidths = () => {
  if (column1.value?.$el) {
    columnWidths[0] = column1.value.$el.offsetWidth;
  }
  if (column2.value?.$el) {
    columnWidths[1] = column2.value.$el.offsetWidth;
  }
};

const setupResizeObserver = () => {
  resizeObserver.value = new ResizeObserver(() => {
    updateColumnWidths();
  });

  if (column1.value?.$el) {
    resizeObserver.value.observe(column1.value.$el);
  }
  if (column2.value?.$el) {
    resizeObserver.value.observe(column2.value.$el);
  }

  // Initial width calculation
  nextTick(() => {
    updateColumnWidths();
  });
};

onMounted(() => {
  setupResizeObserver();
});

onBeforeUnmount(() => {
  if (resizeObserver.value) {
    resizeObserver.value.disconnect();
  }
});
</script>

<template>
  <div class="biomarkerviewer">
    <AnalysisColumn
      ref="column1"
      v-model:active-tab="activeTab"
      :column-i-d="1"
      :width="columnWidths[0]"
    />
    <AnalysisColumn
      ref="column2"
      v-model:active-tab="activeTab"
      :column-i-d="2"
      :width="columnWidths[1]"
    />
  </div>
</template>

<style scoped>
.biomarkerviewer {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 8px;
  padding: 6px;
  overflow: hidden;
  box-sizing: border-box;
}

.biomarkerviewer > * {
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}
</style>
